// @ts-nocheck
import {
  CheckCircleIcon,
  CheckIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
  WarningIcon,
} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Collapse,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  HStack,
  // Icon,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { Field, FieldArray, Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import React from "react";
import useMobileDetect from "use-mobile-detect-hook";
import { number, object, string } from "yup";
import ExpandingTextArea, {
  CustomTextarea,
} from "../components/form-elements/ExpandingTextArea";
import {
  OverlayWrapper,
  useOverlayDisclosure,
} from "../components/OverlayRouter";
import Icon from "../components/ui-elements/Icon";
import { useMedia } from "../components/ui-elements/SizeDetector";
// import { DiscountIcon } from "../icons";
import { ISubjectStore } from "../stores";
import { numberWithCommas } from "../utils/functions";
import { ConfirmationPrompt } from "./forms/SharedComponents";
import { useTitleSuggestion } from "./forms/SubjectTitleForm";

const EDIT_SUBJECT_ACTION = "edit-subject";
const EDIT_PRICE_ACTION = "edit-price";
const HOW_PRICE_WORKS_ACTON = "pricing-tutorial";
const DELETE_SUBJECT_ACTION = "delete-subject";

export const MobileMenuItem: React.FC<{
  onClick: () => void;
  itemName: string;
  itemDescription: string;
  placeholder?: string;
  errorMessage?: string;
  isInvalid?: boolean;
  isPopulated?: boolean;
  [key: string]: any;
}> = ({
  onClick,
  itemName,
  itemDescription,
  isInvalid,
  placeholder,
  errorMessage,
  isPopulated,
  ...rest
}) => {
  return (
    <Box
      py={[3, 4]}
      cursor="pointer"
      borderWidth="2xs"
      borderColor={isInvalid ? "red.500" : "neutral.500"}
      rounded="md"
      onClick={onClick}
      role="group"
      _hover={{ bg: "neutral.100" }}
      {...rest}
    >
      <Flex justifyContent="space-between" align="center">
        <Box width="85%" pl={5}>
          <HStack>
            {isPopulated ? <CheckCircleIcon color="green" /> : null}
            <Text mb={1} fontWeight="medium">
              {itemName}
            </Text>
          </HStack>
          {isInvalid ? (
            <Text fontSize="sm" color="red.500">
              {errorMessage}
            </Text>
          ) : (
            <Text fontSize="sm" color="gray.700" isTruncated opacity={0.8}>
              {itemDescription || placeholder}
            </Text>
          )}
        </Box>

        <Box pr={2}>
          <ChevronRightIcon
            _groupHover={{ color: "blue.500" }}
            fontSize="4xl"
          />
        </Box>
      </Flex>
    </Box>
  );
};

export const MobileMenuDrawer: React.FC<{
  isOpen;
  onClose: () => void;
  subject: any;
  currency: any;
  onMenuClick: (params: any) => void;
}> = ({ isOpen, onClose, subject, currency, onMenuClick }) => {
  const priceDescription = subject.hasUpdatedPrice
    ? `${currency + numberWithCommas(subject.hourRate)} / hour per student`
    : "Set a price";
  const extraStudentDescription = subject.hasUpdatedPrice
    ? `${subject.discountForExtraStudents}% extra charge`
    : "Add extra student fee";

  const subjectActions = [
    {
      action: EDIT_SUBJECT_ACTION,
      title: "Edit subject details",
      description: "This is a test",
    },
    {
      action: EDIT_PRICE_ACTION,
      title: "Update subject price",
      description: "This is a test",
    },
    {
      action: HOW_PRICE_WORKS_ACTON,
      title: "Learn how pricing works",
      description: "This is a test",
    },
    {
      action: DELETE_SUBJECT_ACTION,
      title: "Delete subject",
      description: "This is a test",
    },
  ];
  return (
    <Drawer
      //   scrollBehavior="inside"
      isOpen={isOpen}
      placement="left"
      size="full"
      onClose={onClose}
    >
      <DrawerOverlay />
      <DrawerContent pb={3}>
        <DrawerHeader borderBottomWidth="2xs" display="block" width="100%">
          <Flex align="center" justifyContent="space-between">
            <Box onClick={onClose}>
              <ChevronLeftIcon />
            </Box>
            {/* <Icon variant="unstyled" name="chevron-left" onClick={onClose} /> */}
            <Box textAlign="center">
              <Text fontWeight="normal">{subject.name}</Text>
              <Text
                opacity={0.8}
                textTransform="capitalize"
                fontSize="sm"
                fontWeight="normal"
              >
                {subject.status}
              </Text>
            </Box>
            <Box />
          </Flex>
        </DrawerHeader>

        <DrawerBody px={5} py={6}>
          <Stack pb={4} spacing={12}>
            <Stack>
              <Flex align="center" justifyContent="space-between">
                <Text fontSize="2xl" fontWeight="bolder">
                  About subject
                </Text>
                <Button
                  size="sm"
                  variant="link"
                  colorScheme="blue"
                  rightIcon={<ChevronRightIcon />}
                >
                  Preview
                </Button>
              </Flex>

              <Box>
                <MobileMenuItem
                  itemName="Headline"
                  truncateDescription
                  itemDescription={subject.title}
                  onClick={() => onMenuClick(EDIT_SUBJECT_ACTION)}
                />

                <MobileMenuItem
                  itemName="Description"
                  itemDescription={subject.description}
                  truncateDescription
                  onClick={() => onMenuClick(EDIT_SUBJECT_ACTION)}
                />

                <MobileMenuItem
                  itemName="Certifications"
                  itemDescription="1 added"
                  onClick={() => onMenuClick(EDIT_SUBJECT_ACTION)}
                />
              </Box>
            </Stack>

            <Stack>
              <Text fontSize="2xl" fontWeight="bolder">
                Pricing
              </Text>

              <Box>
                <MobileMenuItem
                  itemName="Hourly rate"
                  itemDescription={priceDescription}
                  onClick={() => onMenuClick(EDIT_PRICE_ACTION)}
                />

                <MobileMenuItem
                  itemName="Additional students"
                  itemDescription={extraStudentDescription}
                  onClick={() => onMenuClick(EDIT_PRICE_ACTION)}
                />

                <Stack
                  spacing={3}
                  py={5}
                  onClick={() => onMenuClick(HOW_PRICE_WORKS_ACTON)}
                >
                  <Flex align="center" justifyContent="space-between">
                    <Text fontSize="lg">How pricing works</Text>
                    <ChevronRightIcon />
                    {/* <Icon name="chevron-right" size={5} /> */}
                  </Flex>

                  {/* <VideoPlaceHolder
                    height={40}
                    hideDescription
                    placeHolderImage="https://pocket-syndicated-images.s3.amazonaws.com/6109ae86db6cc.png"
                  /> */}
                </Stack>
              </Box>
            </Stack>

            <Box mt={-3}>
              <Button
                variant="link"
                onClick={() => onMenuClick(DELETE_SUBJECT_ACTION)}
                colorScheme="red"
                leftIcon={<DeleteIcon />}
              >
                Delete subject
              </Button>
            </Box>
          </Stack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

const SubjectMobileCard = ({
  subjectProps,
  currency,
  store,
  onClick,
  ...rest
}) => {
  return (
    <Box
      px={5}
      py={4}
      as={Stack}
      onClick={onClick}
      borderWidth="3xs"
      borderColor="lightgrey"
      shadow="fbShadow"
      boxShadow="sm"
      rounded="fbRadius"
      role="group"
      cursor="pointer"
      bg="white"
      {...rest}
    >
      <Flex align="center" justifyContent="space-between">
        <Stack width="90%">
          <Text fontWeight="medium" fontSize="lg">
            {subjectProps.name}
          </Text>

          {subjectProps.hasUpdatedPrice ? (
            <Stack isInline align="center">
              <Stack isInline align="center">
                <Icon name="discount" />
                {/* <Icon name="discount" size={3} /> */}
                <Text>
                  {currency + numberWithCommas(subjectProps.hourRate)} / hr
                </Text>
              </Stack>

              <Stack isInline align="center">
                {/* <Icon name="people" size={3} /> */}
                <Icon name="people" />
                <Text>{subjectProps.discountForExtraStudents}% extra</Text>
              </Stack>
            </Stack>
          ) : (
            <Stack color="red.500" isInline align="center">
              {/* <Icon name="warning" size={3} /> */}
              <WarningIcon />
              <Text fontSize="sm">Price hasn't been set</Text>
            </Stack>
          )}
        </Stack>

        <Box _groupHover={{ color: "blue.500" }}>
          <ChevronRightIcon />
          {/* <Icon size={4} name="chevron-right" /> */}
        </Box>
      </Flex>
    </Box>
  );
};

const ListSubjectsByStatus = ({
  onOpen,
  store,
  setEditSubject,
  subjects = [],
  currency,
  subjectStatus,
  ...rest
}) => {
  return (
    <Stack spacing={3} {...rest}>
      <Text fontSize="xl" fontWeight="bold">
        {subjectStatus}
      </Text>
      {subjects.map((subjectProps, idx) => (
        <SubjectMobileCard
          key={idx}
          store={store}
          onClick={() => {
            setEditSubject(subjectProps);
            store.setCurrentSubjectId(subjectProps.id);
            onOpen();
          }}
          currency={currency}
          subjectProps={subjectProps}
        />
      ))}
    </Stack>
  );
};

const SubjectEditDrawer = ({ isOpen, menuAction, onClose, children }) => {
  const isMobile = useMedia("(max-width: 768px)");
  const detectMobile = useMobileDetect();
  const determineHeaderText = () => {
    if (menuAction === EDIT_SUBJECT_ACTION) return "Edit subject details";
    if (menuAction === EDIT_PRICE_ACTION) return "Update price";
    if (menuAction === HOW_PRICE_WORKS_ACTON) return "How pricing works";
    if (menuAction === DELETE_SUBJECT_ACTION) return "Confirm Delete";
    return "";
  };

  if (isMobile) {
    return (
      <Drawer
        // scrollBehavior="inside"
        size="full"
        // isFullHeight
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent my={6} borderRadius="8px 8px 0 0" overflow="hidden">
          <DrawerCloseButton
            rounded="fbRadius"
            borderColor="white"
            borderWidth="2xs"
            color="white"
          />
          <DrawerHeader px={5} py={4} fontSize="md" bg="blue.800" color="white">
            {determineHeaderText()}
          </DrawerHeader>

          <DrawerBody px={5} py={8}>
            {children}
            {detectMobile.isIos() && <Box h={48} />}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  }
  return (
    <Modal isOpen={isOpen} placement="bottom" onClose={onClose}>
      <ModalOverlay />
      <ModalContent pb={3} borderRadius="8px 8px 0 0" overflow="hidden">
        <ModalCloseButton
          rounded="fbRadius"
          borderColor="white"
          borderWidth="2xs"
          color="white"
        />
        <ModalHeader px={5} py={4} fontSize="md" bg="blue.800" color="white">
          {determineHeaderText}
        </ModalHeader>

        <ModalBody p={5}>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
};

const SubjectDescriptionPrompt = () => {
  const [show, setShow] = React.useState(false);
  const handleToggle = () => setShow(!show);
  return (
    <Stack mb={5} fontSize="lg">
      <Text fontWeight="bolder" fontSize="xl">
        2. Describe your expertise
      </Text>
      <Text opacity={0.8}>
        Provide more details to describe your expertise. Highlight your
        professionalism and teaching style, share your most outstanding results
        and let clients know what they can expect from you.
      </Text>

      <Stack
        align="center"
        fontWeight="medium"
        onClick={handleToggle}
        color="blue.500"
        opacity={0.8}
        isInline
      >
        <Link fontSize="md">
          {show ? "Hide the guide" : "See helpful guide"}
        </Link>
        <Icon size={3} name={show ? "triangle-up" : "triangle-down"} />
      </Stack>
      <Collapse p={4} bg="neutral.200" isOpen={show}>
        <Stack fontSize="sm">
          <Text fontSize="xs">
            Let's clients know <b>that you're the best for them</b>. Be creative
            in your description and try to cover these 5 aspects:
          </Text>
          <Text>
            1. Start with a strong, professional introduction that grabs their
            attention
          </Text>
          <Text>
            2. Demonstrate subject mastery. Talk about your experience,
            qualifications and any subject-specific information
          </Text>
          <Text>
            3. Describe your track record. Talk about results you achieved for
            students in the past. Be specific, detailed and honest
          </Text>
          <Text>
            4. Explain your teaching style. Tell clients how you engage your
            students and what they can expect from your lessons
          </Text>
          <Text>
            5. Make it easy to read. Use paragraph spacing, DON'T WRITE IN ALL
            CAPS, check for spelling errors!
          </Text>
        </Stack>
      </Collapse>
    </Stack>
  );
};

const SubjectTitlePrompt = () => {
  const [show, setShow] = React.useState(false);
  const handleToggle = () => setShow(!show);
  return (
    <Stack mb={5} fontSize="lg">
      <Text fontWeight="bolder" fontSize="xl">
        1. Add a subject headline
      </Text>
      <Text opacity={0.8}>
        Write a catchy headline that describes your qualification and experience
        in teaching this subject
      </Text>

      <Stack
        align="center"
        fontWeight="medium"
        onClick={handleToggle}
        color="blue.500"
        opacity={0.8}
        isInline
      >
        <Link fontSize="md">{show ? "Hide examples" : "See examples"}</Link>
        <Icon size={3} name={show ? "triangle-up" : "triangle-down"} />
      </Stack>
      <Collapse p={4} bg="neutral.200" isOpen={show}>
        <Stack fontSize="sm">
          <Text fontSize="xs">
            These are samples. Be creative and write a strong headline that{" "}
            <b>sells your value</b> and is relevant to the client's need
          </Text>
          <Text>
            Certified Montessorian and Earlychild Teacher for Kids aged 2-8
            years
          </Text>

          <Text>
            First Class Physics Tutor. M.Sc in Systems Engineering from
            Cambridge
          </Text>

          <Text>
            Afraid of Math? Get a Math Pro to Help. 100% Pass in all Math Exams
          </Text>

          <Text>
            Expert Phonics Lessons - Your Kids Will Read, Write and Speak
            Correctly
          </Text>

          <Text>Experienced Common Entrance Prep Tutor for over 10 Years</Text>
        </Stack>
      </Collapse>
    </Stack>
  );
};

const SubjectEditForm: React.FC<{
  onClose: () => void;
  store: ISubjectStore;
}> = observer(({ onClose, store }) => {
  const { subject, options, formatInput } = useTitleSuggestion();
  const [loading, setLoading] = React.useState(false);
  const [fieldName, setFieldName] = React.useState("");
  const toast = useToast();

  const [show, setShow] = React.useState(false);
  const handleToggle = () => setShow(!show);

  const validationSchema = object().shape({
    title: string()
      .required("Enter a subject headline")
      .max(70, "Must be 70 characters or less")
      .min(40, "Must be 40 characters at least")
      .nullable(true),
    description: string()
      .required("Please describe your experience")
      .max(1200, "Must be 1200 characters or less")
      .min(400, "Must be 400 characters at least"),
    hourRate: number().required("Please set a price"),
  });

  const titleProps = ({ name }, { touched, errors }) => ({
    placeholder: "Type your subject headline",
    characterLimit: 70,
    isInvalid: Boolean(touched[name] && errors[name]),
    errorMessage: errors[name],
  });

  const descriptionProps = ({ name }, { touched, errors }) => ({
    placeholder: "Type your subject description",
    characterLimit: 1200,
    isInvalid: Boolean(touched[name] && errors[name]),
    errorMessage: errors[name],
  });

  const handleSubmit = async (values, formikHelpers: FormikHelpers<any>) => {
    setLoading(true);
    formikHelpers.setSubmitting(true);
    try {
      const response = await store.updateTutorSubjectInfo({
        ...values,
        // hourRate: store.currentSubject.hourRate,
        hasUpdatedPrice: true,
        certifications: values.certifications,
      });

      toast({
        title: response ? "Subject updated" : "Error updating subject",
        description: response
          ? "Subject updated successfully"
          : "Error updating subject, please try again",
        status: response ? "success" : "error",
        duration: 7000,
        position: "top",
        isClosable: true,
      });
      formikHelpers.setSubmitting(false);
      setLoading(false);
      onClose();
    } catch (error) {
      console.log(error);
      formikHelpers.setSubmitting(false);
      displayToast({
        status: "error",
        title: "",
        duration: 4000,
        position: "top",
        description: "Oops! There was a problem. Please try again",
      });
    }
  };

  return (
    <Formik
      initialValues={{
        ...store?.currentSubject.initialFormData,
        awardName: store.currentSubject.certifications.map((cert) => cert.name),
        awardInstitution: store.currentSubject.certifications.map(
          (cert) => cert.institution,
        ),
      }}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={validationSchema}
    >
      {() => (
        <Form>
          <Stack spacing={6}>
            {store.currentSubject.name && (
              <Stack isInline spacing={3} align="center">
                <Icon name="homework" />
                <Text fontSize="lg">{store.currentSubject.name}</Text>
              </Stack>
            )}

            <Field name="title">
              {({ field, form }) => (
                <FormControl isInvalid={titleProps(field, form).isInvalid}>
                  <SubjectTitlePrompt />
                  <CustomTextarea
                    padding="20px"
                    resize="none"
                    fontSize={["lg", "xl"]}
                    height={["120px", "64px"]}
                    name={field.name}
                    _focus={{
                      borderColor: "blue.500",
                      boxShadow: "0 0 0 1px blue",
                    }}
                    {...titleProps(field, form)}
                    onFocus={({ target }) => setFieldName(target.name)}
                    initialValue={store?.currentSubject.title}
                    onChange={(value) =>
                      form.setFieldValue(field.name, formatInput(value))
                    }
                  />
                  <FormErrorMessage>
                    {titleProps(field, form).errorMessage}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>

            <Box h={6} />

            <Field name="description">
              {({ field, form }) => (
                <FormControl
                  isInvalid={descriptionProps(field, form).isInvalid}
                >
                  <SubjectDescriptionPrompt />
                  <ExpandingTextArea
                    {...field}
                    {...descriptionProps(field, form)}
                    name={field.name}
                    onChange={(value) => {
                      form.setFieldValue(field.name, value);
                    }}
                    onFocus={({ target }) => setFieldName(target.name)}
                    value={store?.currentSubject.description}
                    defaultValue={store?.currentSubject.description}
                  />
                  <FormErrorMessage>
                    {descriptionProps(field, form).errorMessage}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>

            <Box h={6} />

            <Box h={6} />

            <Box size="100%" mt={4}>
              <FormLabel htmlFor="certifications">
                Awards and Certifications
              </FormLabel>
              <FieldArray name="certifications">
                {({ push, form }) => {
                  const certifications = form.values.certifications;
                  return (
                    <Box>
                      {certifications.map((cert, index) => (
                        <Flex key={index} mb={4}>
                          <Input
                            defaultValue={
                              form.values.certifications[index]?.name
                            }
                            placeholder="Award Title"
                            name={`awardName[${index}]`}
                            onChange={({ target }) => {
                              form.setFieldValue(
                                `awardName[${index}]`,
                                target.value,
                              );
                              store.currentSubject.setCertification(
                                target.value,
                                "name",
                              );
                              form.setFieldValue(`certifications[${index}]`, {
                                name:
                                  form.values.awardName[index] ||
                                  store.currentSubject.certification.name,
                                institution:
                                  store.currentSubject.certification
                                    .institution,
                              });
                            }}
                            mr={4}
                          />
                          <Input
                            defaultValue={
                              form.values.certifications[index]?.institution
                            }
                            placeholder="Award Institution"
                            name={`awardInstitution[${index}]`}
                            onChange={({ target }) => {
                              store.currentSubject.setCertification(
                                target.value,
                                "institution",
                              );
                              form.setFieldValue(
                                `awardInstitution[${index}]`,
                                target.value,
                              );
                              form.setFieldValue(`certifications[${index}]`, {
                                name:
                                  form.values.awardName[index] ||
                                  store.currentSubject.certification.name,
                                institution:
                                  store.currentSubject.certification
                                    .institution,
                              });
                            }}
                          />
                        </Flex>
                      ))}
                      <Box
                        color="blue.400"
                        _hover={{ cursor: "pointer" }}
                        onClick={() => push({ name: "", institution: "" })}
                      >
                        <Flex>
                          <Box>
                            <Icon name="small-add" />
                          </Box>
                          <Box>Add more awards</Box>
                        </Flex>
                      </Box>
                    </Box>
                  );
                }}
              </FieldArray>
            </Box>
          </Stack>
          <Button
            float="right"
            color="white"
            bg="blue.500"
            size="lg"
            isFullWidth
            borderRadius="6px"
            mt={2}
            type="submit"
            isLoading={loading}
          >
            Save
          </Button>
        </Form>
      )}
    </Formik>
  );
});

export const SubjectsCardMobile: React.FC<{
  store: any;
  currentSubjects: Array<any>;
  [key: string]: any;
}> = observer(({ store, currentSubjects = [], ...rest }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isDrawerOpen,
    onClose: onDrawerClose,
    onOpen: onDrawerOpen,
  } = useOverlayDisclosure("/edit");
  const [editSubject, setEditSubject] = React.useState({});
  const [isOpenAlert, setIsOpenAlert] = React.useState(false);
  const toast = useToast();
  const onCloseAlert = () => setIsOpenAlert(false);
  const [currency, setCurrency] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [menuAction, setMenuAction] = React.useState(EDIT_SUBJECT_ACTION);
  //   React.useEffect(() => {
  //     getCurrencyForCountry(store.location.country).then((res: any) =>
  //       setCurrency(res)
  //     );
  //   }, []);

  const handleMenuClick = (action) => {
    setMenuAction(action);
    onClose();
    onDrawerOpen();
  };

  const filterSubjects = (filter) => {
    return currentSubjects.filter((subj) => subj.status === filter);
  };

  const activeSubjects = filterSubjects("active");
  const pendingSubjects = filterSubjects("pending");
  const modificationSubjects = filterSubjects("modification");
  const deniedSubjects = filterSubjects("denied");
  const suspendedSubjects = filterSubjects("suspended");

  return (
    <Stack
      h="100vh"
      overflowX="hidden"
      css={{
        "&::-webkit-scrollbar": {
          display: "hidden",
        },
      }}
      px={[5, 8]}
      spacing={3}
      mb={10}
      display={{ xs: "block", sm: "block", md: "none" }}
      bg="neutral.100"
      {...rest}
    >
      <Stack pt={8} px={[5, 0]}>
        <Flex align="center" justifyContent="space-between">
          <Heading fontSize={["2xl", "3xl"]} fontWeight="extrabold">
            {store.tutorSubjects.length} subjects
          </Heading>
          {/* <Button leftIcon="add">Add new</Button> */}
        </Flex>
        <Text fontSize="lg">
          Edit your subjects and pricing to get more bookings
        </Text>
      </Stack>

      <Divider />

      <MobileMenuDrawer
        // isOpen={true}
        isOpen={isOpen}
        currency={currency}
        subject={editSubject}
        onMenuClick={handleMenuClick}
        onClose={onClose}
      />
      <OverlayWrapper path="/edit">
        <SubjectEditDrawer
          isOpen={isDrawerOpen}
          // isOpen={true}
          menuAction={menuAction}
          onClose={onDrawerClose}
        >
          {menuAction === EDIT_SUBJECT_ACTION && (
            <SubjectEditForm store={store} onClose={onDrawerClose} />
          )}
          {menuAction === EDIT_PRICE_ACTION && (
            <Box>Pricing info</Box>
            // <TutorPricing
            //   store={store.pricing}
            //   subjectStore={store}
            //   skipFirstStep
            // />
          )}
        </SubjectEditDrawer>
      </OverlayWrapper>

      <ConfirmationPrompt
        isOpen={isOpenAlert}
        onClose={onCloseAlert}
        loading={loading}
        onDelete={async () => {
          setLoading(true);
          const response = await store.deleteSubject(store.currentSubject);
          toast({
            title: response ? "Subject deleted" : "Error deleting subject",
            description: response
              ? "Subject deleted successfully"
              : "Error deleting subject, please try again",
            status: response ? "success" : "error",
            duration: 7000,
            position: "top",
            isClosable: true,
          });
          setLoading(false);
          setIsOpenAlert(false);
        }}
      />

      <Stack spacing={8}>
        {activeSubjects.length && (
          <ListSubjectsByStatus
            subjectStatus="Active"
            subjects={activeSubjects}
            onOpen={onOpen}
            store={store}
            setEditSubject={setEditSubject}
            currency={currency}
          />
        )}
        {pendingSubjects.length && (
          <ListSubjectsByStatus
            subjectStatus="Pending approval"
            subjects={pendingSubjects}
            onOpen={onOpen}
            store={store}
            setEditSubject={setEditSubject}
            currency={currency}
          />
        )}
        {modificationSubjects.length && (
          <ListSubjectsByStatus
            subjectStatus="Needs review"
            subjects={modificationSubjects}
            onOpen={onOpen}
            store={store}
            setEditSubject={setEditSubject}
            currency={currency}
          />
        )}
        {suspendedSubjects.length && (
          <ListSubjectsByStatus
            subjectStatus="Suspended"
            subjects={suspendedSubjects}
            onOpen={onOpen}
            store={store}
            setEditSubject={setEditSubject}
            currency={currency}
          />
        )}
        {deniedSubjects.length && (
          <ListSubjectsByStatus
            subjectStatus="Denied"
            subjects={deniedSubjects}
            onOpen={onOpen}
            store={store}
            setEditSubject={setEditSubject}
            currency={currency}
          />
        )}
      </Stack>
    </Stack>
  );
});
